import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

const AreaChart = ({ chartData, label, fillHeight }) => {
  // Ensure chartData is always an array, fallback to empty array if it's not
  const safeChartData = Array.isArray(chartData) && chartData.length > 0 ? chartData : [];

  // If chartData is empty or invalid, return a loading message
  if (safeChartData.length === 0) {
    return <div>Loading data or no data available...</div>;
  }

  const chartHeight = fillHeight ? "100%" : (label === "ProductionScan" ? 420 : 310);

  // Highcharts options
  const options = {
    chart: {
      zoomType: "x",
      height: chartHeight,
    },
    title: {
      text: label === "ProductionScan" ? "Daily Scan Pattern" : "",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#333",
      },
      margin: 20,
    },
    xAxis: {
      type: "datetime",
      lineWidth: 0,
      tickLength: 0,
      minorTickLength: 0,
      labels: {
        format: "{value:%d/%m/%Y}",
      },
    },
    tooltip: {
      shared: true,
      xDateFormat: "%A, %d %b %Y",
      headerFormat: "<b>{point.key}</b><br/>",
      pointFormatter: function () {
        const color = this.series.name === "Genuine" ? "#2ecc71" : "#e74c3c";
        return `<span style="color:${color}">\u25CF</span> ${this.series.name}: <b>${this.y}</b><br/>`;
      },
    },
    yAxis: {
      title: {
        text: "No. of Scans",
        style: {
          fontSize: '16px',
          color: '#001323'
        }
      },
      gridLineDashStyle: 'Dash',
    },
    scrollbar: {
      enabled: true,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
        },
        threshold: null,
      },
    },
    series: [
      {
        type: "areaspline",
        name: "Genuine",
        data: safeChartData.map((item) => [
          item?.DATE_KEY, 
          item?.genuine_count || 0
        ]),
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(46, 204, 113, 0.7)"],
            [1, "rgba(46, 204, 113, 0.1)"],
          ],
        },
        marker: {
          enabled: safeChartData.length === 1, // Enable markers only for single data point
          radius: 4,
          fillColor: "#2ecc71", // Green
          lineWidth: 2,
          lineColor: "#2ecc71",
          symbol: "circle",
        },
        lineColor: "#2ecc71",
      },
      {
        type: "areaspline",
        name: "Counterfeit",
        data: safeChartData.map((item) => [
          item?.DATE_KEY, 
          item?.counterfeit_count || 0
        ]),
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "#C87171"],
            [1, "rgba(231, 76, 60, 0.1)"],
          ],
        },
        marker: {
          enabled: safeChartData.length === 1, // Enable markers only for single data point
          radius: 4,
          fillColor: "#e74c3c", // Red
          lineWidth: 2,
          lineColor: "#e74c3c",
          symbol: "circle",
        },
        lineColor: "#e74c3c",
      },
    ],
  };

  const wrapperHeight = fillHeight ? "100%" : (label === "ProductionScan" ? "450px" : "338px");

  return (
    <div style={{ height: wrapperHeight }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default AreaChart;
